import { useState } from 'react';
import Box from '@mui/material/Box';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import Buttons from '../../../../../../../../components/forms/Buttons';
import { FormSelect } from '@omnigenbiodata/ui';
import { sequencersSelector } from '../../../../../../../../store/print';
import { useAppSelector } from '../../../../../../../../store';

interface SelectionTableProps {
  mode?: string;
  data: any;
  title?: string;
  loading: boolean;
  printFn: (selection: string[]) => void;
  setSequencer?: any;
  sequencer?: string;
  sequencersList?: string[];
}

const columns = [
  { field: 'id', headerName: 'Participant ID', flex: 2 },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
  },
];

function SelectionTable({ mode, data, loading, printFn, setSequencer, sequencer }: SelectionTableProps) {
  const apiRef = useGridApiRef();
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const sequencersList = useAppSelector(sequencersSelector);

  const submit = () => {
    if (rowSelectionModel.length > 0) {
      printFn(rowSelectionModel);
    }
  };

  const handleSelection = (newSelection: any) => {
    setRowSelectionModel(newSelection.slice(0, 50));
  };
  return (
    <>
      <Box sx={{ width: '100%', marginBottom: 2 }}>
        {mode === 'PENDING' && (
          <FormSelect
            placeholder=""
            name="sequencers"
            label={'Sequencers'}
            onChange={(e: any) => {
              setSequencer(e.currentTarget.value);
            }}
            onBlur={() => {}}
            value={sequencer || ''}
            options={sequencersList.map((gender) => ({
              value: gender,
              label: gender,
            }))}
          />
        )}
        <DataGrid
          apiRef={apiRef}
          loading={loading}
          rows={data}
          autoHeight
          pageSizeOptions={[10, 25, 50]}
          checkboxSelection
          columns={columns}
          onRowSelectionModelChange={handleSelection}
          rowSelectionModel={rowSelectionModel}
          initialState={{
            ...data.initialState,
            pagination: { paginationModel: { pageSize: 50 } },
          }}
        />
      </Box>
      <Buttons onForward={submit} forwardLabel="Print" />
    </>
  );
}

export default SelectionTable;
